import '../Sidebar/Sidebardigital';
import Sidebarfarmer from '../Sidebar/Sidebarfarmer';
import Sidebarblank from '../Sidebar/Sidebarblank';
import React from 'react';

export default function Farmer()
{
    return(
       <>
      
       <div className="row">
       <div className="col-2 custom-display">
         <Sidebarfarmer />
       </div>
       <div className="col-8 custom-width">
       <br></br><br></br>
       <ui><h2>For the regenerative Agriculture</h2><br></br></ui><br></br>
       <strong> For the new crop selection, there are various factors to be considered. Some of these factors would include-</strong>
       <br></br><br></br>
       <p>1) Market for the crop</p>
       <p>2) Resources required - seed type, irrigation requirement, inputs availability and labour intensiveness etc</p>
       <p>3) Finacial calculation - different scenarios to be covered</p><br></br>

       <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
       <p>More details to follow soon</p>
       </div>
       <div className="col-2 custom-display">
         <Sidebarblank />
       </div>
       </div>       
       </>
    )   
   };